<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid [dataSource]="viewModel.dataSource" [showBorders]="true">
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="companyId"
			caption="Company"
			[allowEditing]="false"
		>
			<dxo-lookup
				[dataSource]="viewModel.companyDatasource"
				valueExpr="id"
				[displayExpr]="companyIdDisplayExpr"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="userId"
			caption="User"
			[allowEditing]="false"
		>
			<dxo-lookup
				[dataSource]="viewModel.userDatasource"
				valueExpr="id"
				[displayExpr]="userIdDisplayExpr"
			>
			</dxo-lookup>
		</dxi-column>

		<dxi-column type="buttons">
			<dxi-button icon="far fa-check btn-succes" hint="Aprove" [onClick]="approve.bind(this)">
			</dxi-button>
			<dxi-button icon="far fa-ban btn-danger" hint="Reject" [onClick]="reject.bind(this)">
			</dxi-button>
		</dxi-column>
	</dx-data-grid>
</ng-container>
